import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { Link } from 'react-router-dom';


const ViewProject = ({projectId, list}) => {
    const [projectData, setProjectData] = useState(null);
    const [teamLead, setTeamLead] = useState([]);
    
    const fetchProjects = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects/${Id}`)
            .then(response => {
                setProjectData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setProjectData([]); 
            });
    }

    const fetchTeamLead = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=teamleads`)
            .then(response => {
                setTeamLead(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching teamleads', error);
                setTeamLead([]);
            });
    };

    useEffect(() => {
        if (projectId) {
            fetchProjects(projectId);
        }
        fetchTeamLead();
    }, [projectId]);


    if (!projectId || !projectData) {
        return null;
    }


    return (
        <div id={`view_project_${projectId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">View Project - {projectData.title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <input className="form-control" type="text" value={projectData.channel || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client</label>
                                        <input className="form-control" type="text" value={projectData.client || ""} disabled />
                                    </div>
                                </div>                               
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Team Lead</label>
                                        <select className="form-control" value={projectData.team_lead_id || ""} >
                                            <option value="">Select Team Lead</option>
                                            {teamLead.map(tl => (
                                                <option key={tl.id} value={tl.id}>{tl.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Start Date</label>
                                        <input className="form-control" type="date" value={projectData.start_date || ""} />
                                    </div>
                                </div>
                                {projectData.channel !== 'Upwork' &&
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">Amount</label>
                                            <input className="form-control" type="text" value={projectData.amount} />
                                        </div>
                                    </div>
                                }                                
                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description</label>
                                        <textarea className="form-control" value={projectData.description || ""} rows={3}></textarea>
                                    </div>
                                </div>

                                
                                {projectData.files && projectData.files.length > 0 && (
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">Files</label>
                                        </div>

                                        {projectData.files.map((file, index) => (
                                            <div key={index}>
                                                <Link to={`${process.env.REACT_APP_API_FILE_URL}/${file}`} className="btn btn-secondary btn-sm mb-3" target="_blank" rel="noopener noreferrer">
                                                    Document {++index}
                                                </Link>
                                                <br />
                                            </div>                                        
                                        ))}
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewProject